import { toast } from 'react-toastify'

/**
 * Show toast message
 * @param {string} message
 * @param {string} type
 *
 * @returns {toast}
 */
export function toastMessage(message, type = 'info', options) {
  if (type === 'info')
    return toast(message, { position: 'top-center', autoClose: 4000, ...options || {} })
  else if (type === 'error')
    return toast(message, { position: 'top-center', autoClose: 4000, progressClassName: 'toast-error', ...options || {} })
}
